// File for project's constants

// Notes:
// API communication now happens securely through Netlify function proxies
// No API keys are exposed to the frontend

// Backend API URL
export const getBackendUrl = async () => {

  const response = await fetch('/.netlify/functions/getSecret');
  const data = await response.json();

  return data.baseUrl

};


// Backend API URL
export const isDevelopment = async () => {
  const val = process.env.IS_DEVELOPMENT;
  return typeof val === 'string' && val.toLowerCase() === 'true';
};


// General Configurations
export const MAX_ANNOTATION_RESULT_STACK_SIZE = 10


// Languages
export const EN = "en"
export const ES = "es"
export const EE = "ee"

// General Constants
export const MESSAGE = "message"
export const CONTEXT = "context"
export const LEFT = "left"
export const RIGHT = "right"
export const DOMAIN = "domain"
export const KINGDOM = "kingdom"
export const PHYLUM = "phylum"
export const CLASS = "class"
export const ORDER = "order"
export const FAMILY = "family"
export const GENUS = "genus"
export const SPECIES = "species"
export const ID = "id"


// Pages
export const PAGE_HOME = "/"
export const PAGE_ALIGNMENT_RESULTS = "/alignment_results"
export const PAGE_ANNOTATION_RESULTS = "/annotation_results"
export const PAGE_DOCS_METHODS = "/docs/methods"
export const PAGE_DOCS_GETTING_STARTED = "/docs/getting_started"
export const PAGE_DOCS_RESOURCES = "/docs/resources"
export const PAGE_BUG_REPORT = "/bug_report"


// Store Management Constants
export const KEY = "KEY"
export const VALUE = "VALUE"
export const KEY_VALUE_DICT = "KEY_VALUE_DICT"


// Status constants
export const STATUS_OK = "STATUS_OK"
export const STATUS_ERROR = "STATUS_ERROR"
export const STATUS_NOT_STARTED = "STATUS_NOT_STARTED"
export const STATUS_PROCESSING = "STATUS_PROCESSING"



// Specific sequence status
export const STATUS_IS_MISSING = "STATUS_IS_MISSING"
export const STATUS_UNPARSABLE = "STATUS_UNPARSABLE"

// Store Constants
// --------------
// User Experience
export const SELECTED_DATABASE = "SELECTED_DATABASE"
export const STORAGE_CURRENT_LOCAL = "STORAGE_CURRENT_LOCALE"
export const INPUT_TEXT_SEQUENCE_STATUS = "INPUT_TEXT_SEQUENCE_STATUS"
export const INPUT_TEXT_SEQUENCE_MESSAGE = "INPUT_TEXT_SEQUENCE_MESSAGE"
export const INPUT_TEXT_SEQUENCE_MESSAGE_CONTEXT = "INPUT_TEXT_SEQUENCE_MESSAGE_CONTEXT"
export const UPLOADED_FILE_SEQUENCE_STATUS = "UPLOADED_FILE_SEQUENCE_STATUS"
export const UPLOADED_FILE_SEQUENCE_MESSAGE = "UPLOADED_FILE_SEQUENCE_MESSAGE"
export const UPLOADED_FILE_SEQUENCE_MESSAGE_CONTEXT = "UPLOADED_FILE_SEQUENCE_MESSAGE_CONTEXT"
// export const PROCESSING_SEQUENCE_STATUS = "PROCESSING_SEQUENCE_STATUS"
export const PROCESSING_SEQUENCE_MESSAGE = "PROCESSING_SEQUENCE_MESSAGE"
export const SERVER_STATUS = "SERVER_STATUS"


// Constants for storing input sequence and uploaded file
export const TEXT_INPUT = "TEXT_INPUT"
export const FILE_INPUT = "FILE_INPUT"


export const INPUT_TEXT_SEQUENCE = "INPUT_TEXT_SEQUENCE"
export const UPLOADED_FILE_NAME = "UPLOADED_FILE_NAME"
export const FINAL_INPUT_SEQUENCE = "FINAL_INPUT_SEQUENCE"

// Job information (also used for bug reports)
export const CURRENT_FILE_ID = "CURRENT_FILE_ID"
export const CURRENT_JOB_ID = "CURRENT_JOB_ID"
export const SELECTED_METHOD = "SELECTED_METHOD"

// Constants for annotation results
export const ANNOTATION_RESULT_DATA = "ANNOTATION_RESULT_DATA"
export const SELECTED_ANNOTATION_QUERY_ID = "SELECTED_ANNOTATION_QUERY_ID"
export const SELECTED_ALIGNMENT_RESULT_HIT_ID = "SELECTED_ANNOTATION_RESULT_HIT_ID"

export const IS_EXPERIMENTAL = "IS_EXPERIMENTAL"

// --------------

// Database Constants
export const DATABASE_ITS = "ITS"
export const DATABASE_SSU = "SSU"
export const DATABASE_LSU = "LSU"
export const DATABASE_LrRNA = "LrRNA"

export const ANNOTATION_METHOD_BLAST = "BLAST"
export const ANNOTATION_METHOD_MEGABLAST = "MEGABLAST"
export const ANNOTATION_METHOD_VSEARCH = "VSEARCH"
export const ANNOTATION_METHOD_EXACT = "EXACT"


// Sequence Messages
export const SEQUENCE_MESSAGE_OK = "sequenceMessageOk"
export const SEQUENCE_MESSAGE_ERR_NO_SEQUENCE = "sequenceMessageNoSequence";
export const SEQUENCE_MESSAGE_ERR_INVALID_FORMAT = "sequenceMessageInvalidFormat"
export const SEQUENCE_MESSAGE_ERR_INVALID_CHARACTERS = "sequenceMessageInvalidCharacters"
export const SEQUENCE_MESSAGE_ERR_TOO_MANY_RECORDS = "sequenceMessageTooManyRecords"
export const SEQUENCE_MESSAGE_ERR_TOTAL_LENGTH = "sequenceMessageTotalLength"

// Annotation/Alignment Results Constants (ARC)
export const ARC_QUERY_ID = "query_id"
export const ARC_QUERY_LENGTH = "query_length"
export const ARC_HIT_COUNT = "hit_count"
export const ARC_HITS = "hits"
export const ARC_SSQID = "sseqid"
export const ARC_QSTART = "qstart"
export const ARC_QEND = "qend"
export const ARC_LENGTH = "length"
export const ARC_MISMATCH = "mismatch"
export const ARC_GAPOPEN = "gapopen"
export const ARC_SSTART = "sstart"
export const ARC_SEND = "send"
export const ARC_EVALUE = "evalue"
export const ARC_BITSCORE = "bitscore"
export const ARC_SSTRAND = "sstrand"
export const ARC_TAXONOMY = "taxonomy"
export const ARC_ALIGNMENT = "alignment"
export const ARC_QSEQ = "qseq"
export const ARC_MIDLINE = "midline"
export const ARC_SSEQ = "sseq"
export const ARC_PIDENT = "pident"
export const ARC_QCOVS = "qcovs"
export const ARC_TARGET_LENGTH = "slen"
export const ARC_TAXONOMY_STRING = "taxonomy_string"
export const ARC_JOB_ID = "job_id"
export const ARC_ALGORITHM = "algorithm"
export const ARC_TOOL = "tool"
export const ARC_DATABASE = "database"
export const ARC_IDENTIFIER = "identifier"
export const ARC_TOTAL_QUERIES = "total_queries"
export const ARC_TOTAL_HITS = "total_hits"
export const ARC_METADATA = "metadata"
export const ARC_SUMMARY = "summary"
export const ARC_RESULTS = "results"

export const ARC_PLUS = "plus"


// Other
export const MISSING_VALUE = "---"

export const TAXONOMIC_LEVELS = [
  KINGDOM,
  PHYLUM,
  CLASS,
  ORDER,
  FAMILY,
  GENUS,
  SPECIES]


// Server Constants
export const HEALTHY = "healthy" 


// Limit Sequence Constants
export const DEFAULT_MAX_RECORDS = 10;
export const DEFAULT_MAX_TOTAL_LENGTH = 100000;